import styled from 'styled-components';
import MUIButton from '@material-ui/core/Button';

import { WithMyTheme } from '@keaze/web/theme';

export const Button = styled(MUIButton)`
  ${({
    theme: {
      palette,
      breakpoints,
      transitions: { easing, duration },
    },
  }: WithMyTheme) => `
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 50px;
    border-radius: 0;
    padding: 0;
    min-width: auto;
    overflow: hidden;
    backdrop-filter: blur(7px);
    transition: ${duration.standard}ms ${easing.easeInOut};
    z-index: 9;

    &:first-child {
      left: 0;
    }

    &:last-child {
      right: 0;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${palette.common.white};
      transition: ${duration.standard}ms ${easing.easeInOut};
      opacity: 0.2;
      z-index: -1;
    }

    svg {
      fill: ${palette.primary.main};
      font-size: 2.2rem;
    }

    &.MuiButton-root {
      &:hover {
        &:not(&.Mui-disabled) {
          &::before {
            background-color: ${palette.common.white};
            opacity: 0.9;
          }

          svg {
            fill: ${palette.secondary.main};
          }
        }
      }
    }

    ${breakpoints.up('md')} {
      width: 48px;
      height: 80px;

      &:first-child {
        left: -50px;
      }

      &:last-child {
        right: -50px;
      }
      
      svg {
        font-size: 3.2rem;
      }
    }
  `}
`;
